export const defaultWaitSettings = () => ({
    values: {
        waitInterval: {
            value: '',
            required: true
        },
        useTimeInterval: false,
    },
    minDispatchTime: '08:00',
    maxDispatchTime: '20:00',
})
